define(['exports', 'react', 'deep-equal', './gauge'], function (exports, _react, _deepEqual, _gauge) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true
			});
		} else {
			obj[key] = value;
		}

		return obj;
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var SexyGaugeCanvas = function (_Component) {
		_inherits(SexyGaugeCanvas, _Component);

		function SexyGaugeCanvas(props) {
			_classCallCheck(this, SexyGaugeCanvas);

			var _this = _possibleConstructorReturn(this, (SexyGaugeCanvas.__proto__ || Object.getPrototypeOf(SexyGaugeCanvas)).call(this, props));

			_this.state = {
				gauge: ''
			};
			return _this;
		}

		_createClass(SexyGaugeCanvas, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props,
				    canvasId = _props.canvasId,
				    currentValue = _props.currentValue,
				    labels = _props.labels,
				    staticZones = _props.staticZones,
				    totalValue = _props.totalValue;


				var canvasElement = document.getElementById(canvasId); // canvas element
				var gauge = new _gauge.Gauge(canvasElement);

				this.state.gauge = gauge;

				this.setGaugeProperties(labels, staticZones, totalValue, currentValue);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!(0, _deepEqual2.default)(this.props, nextProps)) {
					var labels = nextProps.labels,
					    staticZones = nextProps.staticZones,
					    totalValue = nextProps.totalValue,
					    currentValue = nextProps.currentValue;

					this.setGaugeProperties(labels, staticZones, totalValue, currentValue);
				}
			}
		}, {
			key: 'getGaugeOptions',
			value: function getGaugeOptions(labels, staticZones) {
				var _opts;

				var opts = (_opts = {
					angle: -0.3,
					lineWidth: 0.2,
					limitMax: 'true',
					strokeColor: 'red',
					radiusScale: 0.8,
					generateGradient: true,
					pointer: {
						length: 0.58, // // Relative to gauge radius
						strokeWidth: 0.3, // The thickness
						color: '#E0E0E0', // Fill color,
						shadowColor: '#999',
						shadowBlur: 0.5
					},
					staticLabels: {
						font: "90% sans-serif", // Specifies font
						labels: [],
						// labels: labels,  // Print labels at these values
						color: "black", // Optional: Label text color
						fractionDigits: 2 // Optional: Numerical precision. 0=round off.
					}
				}, _defineProperty(_opts, 'strokeColor', 'red'), _defineProperty(_opts, 'staticZones', staticZones), _defineProperty(_opts, 'generateGradient', true), _opts);

				return opts;
			}
		}, {
			key: 'setGaugeProperties',
			value: function setGaugeProperties(labels, staticZones, totalValue, currentValue) {
				var gauge = this.state.gauge;

				var gaugeOptions = this.getGaugeOptions(labels, staticZones);

				gauge.setOptions(gaugeOptions);

				gauge.maxValue = totalValue; // set max gauge value

				gauge.animationSpeed = 32; // set animation speed (32 is default value)
				gauge.set(currentValue); // set current gauge value
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('canvas', { width: '200', height: '150', id: this.props.canvasId })
				);
			}
		}]);

		return SexyGaugeCanvas;
	}(_react.Component);

	exports.default = SexyGaugeCanvas;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/SexyGaugeCanvas.js
// module id = 1186
// module chunks = 0